import { render, staticRenderFns } from "./projectCreditsDetail.vue?vue&type=template&id=7b222cf5&scoped=true&"
import script from "./projectCreditsDetail.vue?vue&type=script&lang=js&"
export * from "./projectCreditsDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectCreditsDetail.vue?vue&type=style&index=0&id=7b222cf5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b222cf5",
  null
  
)

export default component.exports